const _ = require('lodash');

/**
 * Clona un arreglo u objeto
 */
const cloneObjectArray = (objectArray)=>{
    return  _.cloneDeep(objectArray);
}

/**
 * Remueve objectos repetidos en el arreglo
 * @param {*} arreglo 
 * @returns 
 */
const removeDuplicateObjects = (arreglo) => {
    return [...new Set(arreglo.map(s => JSON.stringify(s)))]
      .map(s => JSON.parse(s));
  }

/**
 * Verifica si el objecto está vacio
 * @param {*} value 
 * @returns 
 */
const isEmpty = value =>{
    return _.isEmpty(value);
}

/**
 * Valida si los dos objectos son iguales
 * @param {*} obj1 
 * @param {*} obj2 
 * @returns 
 */
const isEqual = (obj1,obj2) =>{
    return _.isEqual(obj1, obj2);
}

/**
 * Asigna los nuevos elementos del objecto y sobreescribe los que ya existen
 * @param {*} obj1 
 * @param {*} obj2 
 * @returns 
 */
const override = (obj1,obj2) =>{
   return  _.assign({}, obj1, obj2);
}
export const objectFunctionHelpers = {
    cloneObjectArray: cloneObjectArray,
    removeDuplicateObjects: removeDuplicateObjects,
    isEmpty: isEmpty,
    isEqual: isEqual,
    override: override
}